<template>
  <div class="ukey">
    <div class="ukey-box">
    <header>绑定Ukey盒子</header>
    <p>本向导将指引您注册或登录账号，并将此终端绑定至您名下</p>
    <div class="ukey-box-model">
      <img src="../../../../src/assets/img/ukeyBox.png" class="ukey-img"/>
    </div>
    <div class="ukey-box-message">
      <div class="ukey-name">
        <span>型号</span><span>{{ 'Ukey盒子' }}</span>
      </div>
      <div class="ukey-code">
        <span>设备SN</span><span>{{ boxCode ? boxCode : '--' }}</span>
      </div>
    </div>
    <div class="set-phone">
      <van-field
        v-model="phone"
        type="number"
        input-align="center"
        maxlength="13"
        :placeholder="showPlaceholder ? '请输入您的手机号以继续下一步' : '' "
        @input="validatephone($event)"
        @focus="handleFocusOrBlur('focus')"
        @blur="handleFocusOrBlur('blur')"
      />
      <i v-if="testPhone" class="huisuiyunfont ok">{{'\ue614'}}</i>
    </div>
    <div :class="['next-step',testPhone ? '' : 'disabled-button']" @click="testPhone ? handleClick() : hangdleWrong() ">
      下一步
    </div>
  </div>
  </div>
</template>
<script>
import { Field, Notify } from 'vant'
import { ukeyBoxRequest } from '@services'
import { getQuery, aesDoDecrypt } from '@/utils/basicUtil'
export default {
  data () {
    return {
      boxCode: '0123213213213213',
      phone: '',
      showPlaceholder: true
    }
  },
  methods: {
    validatephone (val) {
      if (val.length === 11) {
        let newVal = val + ''
        this.phone = newVal.substr(0, 3) + ' ' + newVal.substr(3, 4) + ' ' + newVal.substr(7)
      } else {
        this.phone = val
      }
    },
    handleClick () {
      let phone = this.phone.split(' ')[0] + '' + this.phone.split(' ')[1] + '' + this.phone.split(' ')[2]
      let ref = /0?(13|14|15|18|17|19|16)[0-9]{9}/
      if (ref.test(phone)) {
        let ukeyBox = {
          phone: phone,
          boxCode: this.boxCode
        }
        sessionStorage.ukeyBox = JSON.stringify({ ...ukeyBox })
        this.$router.push({ path: '/ukey/send-code' })
      } else {
        Notify({ type: 'danger', message: '手机格式不正确' })
      }
    },
    hangdleWrong () {
      Notify({ type: 'danger', message: '手机格式不正确' })
    },
    handleFocusOrBlur (type) {
      if (type === 'focus') {
        this.showPlaceholder = false
      } else {
        this.showPlaceholder = true
      }
    }
  },
  computed: {
    testPhone () {
      let phone = this.phone.split(' ')[0] + '' + this.phone.split(' ')[1] + '' + this.phone.split(' ')[2]
      let ref = /0?(13|14|15|18|17|19|16)[0-9]{9}/
      if (ref.test(phone)) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    [Field.name]: Field
  },
  async created () {
    let { sn } = getQuery()
    let boxCode = aesDoDecrypt(sn)
    // 拿到sn号
    sessionStorage.boxCode = boxCode
    this.boxCode = boxCode
    let data = await ukeyBoxRequest.ukeyBox.getValidDevice({ boxCode: this.boxCode })
    if (data.success) {
      if (data.result) {
      } else {
        this.$router.push('/ukey/noDisc')
      }
    } else {
      Notify({ type: 'danger', message: data.message })
    }
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
